/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { Action } from '../../../../components/ActionsCard/ActionCard';
import { strings } from '../../../../intl/Strings';
import { logger } from '../../../../shared';
import { TrialActionId } from '../shared';

export const ExcelBrainstormActionCard = (showSecondary: boolean = true): Action => ({
    id: TrialActionId.BrainStormDialog,
    checked: false,
    primaryContent: strings.getString('trialconversionExcelBrainStormDialogHeader'),
    secondaryContent: strings.getString('trialconversionExcelBrainStormDialogContent'),
    showSecondaryContent: showSecondary,
    onClick: () => logger.logInfo('TrialConversionExcelCard', 'Backup your files clicked'),
    retriggerable: true
});
